import React from 'react';

function UserRole(props) {
  let humanizedRole = <div></div>;
  if (props.role == "client")
  {
    humanizedRole = <div>Client</div>
  }
  else
  {
    let to_lower = props.role.replace("dp_", "")
    let firstCap = to_lower.charAt(0).toUpperCase() + to_lower.slice(1);
    humanizedRole = <div>{firstCap}</div>
  }
  return humanizedRole;
}

export default UserRole;